import CapabilitiesEditorSubmitButtonText from './CapabilitiesEditorSubmitButtonText';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * @description The default submit button for sending
 * replies. It has some edge casing for email behavior that
 * should eventually be made generic to support any channel
 * that allows sending to multiple recipients.
 */
const ReplySubmitButton = ({
  disabled,
  onClick,
  genericChannelId = 'UNSET',
  buttonRef,
  recipientCount = 0,
  macroSelected = false,
  compact = false
}) => {
  const renderRecipientTooltip = compact && recipientCount > 1 && !disabled;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.send-button.capabilities-editor-submit-button.send-count-tooltip",
      options: {
        count: recipientCount
      }
    }),
    disabled: !renderRecipientTooltip,
    children: /*#__PURE__*/_jsx(Button, {
      disabled: disabled,
      onClick: onClick,
      buttonRef: buttonRef,
      use: "primary",
      size: "small",
      "data-test-id": "composer-send-button",
      children: /*#__PURE__*/_jsx(CapabilitiesEditorSubmitButtonText, {
        editorConfigurationKey: genericChannelId,
        count: recipientCount,
        macroSelected: macroSelected,
        compact: compact
      })
    })
  });
};
ReplySubmitButton.displayName = 'ReplySubmitButton';
export default ReplySubmitButton;